import { MSMRequest } from "../api/msm";
import store from "../state/store";
import { safeRegisterTool } from "./registerTool";

// Campi con dati personali: nel log di utilizzo diventano solo flag di presenza.
const LOG_REDACT = ["nome", "cognome", "telefono", "email", "note"];

const textResult = (text, extra = {}) => ({
  content: [{ type: "text", text }],
  ...extra,
});

const getTrackingValues = () => {
  const s = store.getState().config?.settings || {};
  return {
    gclid: s.gclid || null,
    msmlid: s.msmlid || null,
    utm_source: s.utmSource || null,
    utm_campaign: s.utmCampaign || null,
    utm_medium: s.utmMedium || null,
    lastMethodLid: s.lastMethodLid || null,
    msclkid: s.msclkid || null,
    QueryStringValues: { ...(s.queryStringValues || {}) },
  };
};

/**
 * Registra il tool WebMCP per la richiesta di consulenza gratuita.
 * Funziona da qualsiasi pagina — non richiede che il form sia aperto.
 */
export function registerConsulenzaTools(modelContext) {
  if (!modelContext) return () => {};

  const unregFn = safeRegisterTool(modelContext, {
    name: "richiedi_consulenza_gratuita",
    description:
      "Invia una richiesta di consulenza gratuita per un mutuo. " +
      "Chiedi sempre all'utente il consenso esplicito al trattamento dei dati personali " +
      "prima di chiamare questo tool. Funziona da qualsiasi pagina del sito.",
    inputSchema: {
      type: "object",
      properties: {
        nome: { type: "string", description: "Nome del richiedente." },
        cognome: { type: "string", description: "Cognome del richiedente." },
        telefono: {
          type: "string",
          description: "Numero di telefono (es. 3401234567 o +393401234567).",
        },
        email: { type: "string", description: "Indirizzo e-mail." },
        note: {
          type: "string",
          description: "Note o messaggio aggiuntivo (facoltativo).",
        },
        privacyAccettata: {
          type: "boolean",
          description:
            "Deve essere true solo se l'utente ha esplicitamente dichiarato di accettare " +
            "il trattamento dei propri dati personali. Non impostare a true senza aver " +
            "ricevuto conferma verbale dall'utente.",
        },
      },
      required: ["nome", "cognome", "telefono", "email", "privacyAccettata"],
    },
    execute: async ({ nome, cognome, telefono, email, note, privacyAccettata }) => {
      if (!privacyAccettata) {
        return textResult(
          "Invio bloccato: l'utente non ha ancora accettato il trattamento dei dati personali. " +
            "Chiedi conferma prima di procedere.",
          { isError: true }
        );
      }

      const tracking = getTrackingValues();

      let response;
      try {
        response = await MSMRequest("FattiChiamare", {
          Nome: nome,
          Cognome: cognome,
          Telefono01: telefono,
          Email: email,
          Note: note || "",
          CodiceOriginator: 1,
          privacy: true,
          ...tracking,
        });
      } catch (err) {
        return textResult(`Errore di rete: ${err.message}`, { isError: true });
      }

      if (response?.success) {
        return textResult(
          "Richiesta inviata con successo. Un consulente contatterà l'utente a breve."
        );
      }
      return textResult(
        "Errore durante l'invio della richiesta. Riprova più tardi.",
        { isError: true }
      );
    },
  }, { redact: LOG_REDACT });

  return typeof unregFn === "function" ? unregFn : () => {};
}
